import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import RevisionPolicyNotice from '../../components/common/RevisionPolicyNotice';
import { ORDER_MENU, DesignType } from './orderMenu';
import head from '../Works/Works.module.scss';
import styles from './OrderStart.module.scss';

const CARD_ICON: Record<DesignType, ReactNode> = {
  NONE: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
    </svg>
  ),
  HAVE: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 9V2h12v7" />
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
      <rect x="6" y="14" width="12" height="8" />
    </svg>
  ),
};

const CARD_POINTS: Record<DesignType, string[]> = {
  NONE: ['상품 선택 → 주문서 작성', '1:1 시안 확인 · 수정요청', '최종 승인 후 결제 · 제작 · 배송'],
  HAVE: ['인쇄 상품 · 용지 · 옵션 선택', '실시간 가격 확인', '파일 첨부 후 주문서 작성'],
};

// 주문하기 진입 화면: 디자인 유무에 따라 두 가지 주문 흐름으로 나눈다
function OrderStart() {
  return (
    <div className={head.page}>
      <section className={head.pageHead}>
        <div className={head.crumb}>
          <Link to="/">HOME</Link>
          <svg viewBox="0 0 24 24">
            <path d="m9 18 6-6-6-6" />
          </svg>
          <span className={head.crumbHere}>주문하기</span>
        </div>
        <span className={head.eyebrow}>Order</span>
        <h1 className={head.pageTitle}>
          <em>주문하기</em>
        </h1>
        <p className={head.pageDesc}>디자인 파일이 있으신가요? 상황에 맞는 주문 방법을 선택해주세요.</p>
      </section>

      <section className={head.layout}>
        <div className={styles.cards}>
          {ORDER_MENU.map((m) => (
            <Link key={m.designType} to={m.to} className={styles.card}>
              <span className={styles.cardIcon}>{CARD_ICON[m.designType]}</span>
              <strong className={styles.cardTitle}>{m.label}</strong>
              <p className={styles.cardDesc}>{m.desc}</p>
              <ol className={styles.cardSteps}>
                {CARD_POINTS[m.designType].map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ol>
              <span className={styles.cardCta}>
                선택하기
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12h14" />
                  <path d="m13 6 6 6-6 6" />
                </svg>
              </span>
            </Link>
          ))}
        </div>

        <RevisionPolicyNotice className={styles.policy} />

        <p className={styles.help}>
          어떤 방법이 맞는지 모르겠다면 <Link to="/quote">견적문의</Link>로 남겨주세요. 담당자가 확인 후 안내해드립니다.
        </p>
      </section>
    </div>
  );
}

export default OrderStart;
